export const version = "random/5.5.1";
//# sourceMappingURL=_version.js.map